export const MAX_DISPLAY_ONBOARDING_COUNT = 3;
export const ROUTE_ONBOARDING_CONFIG_KEY = 'distance-calculating.onboardingEnabled';
export const ROUTE_ONBOARDING_STORAGE_KEY = 'distance_calculating_onboarding_counter';
export const YANDEX_API_TELEMETRY_KEY = 'yandexApi.requestsCount';
